async function getUserIdAndOtherDetails() {
  console.log(localStorage.getItem("user"));
  const user = JSON.parse(localStorage.getItem("user")).result[0].user;
  return JSON.stringify(user);
}

export default {
  getUserIdAndOtherDetails,
  miscTools:[
    {
      type: "function",
      function: {
        name: "getUserIdAndOtherDetails",
        description:
          "Get user details including its id , name , designation etc.",
        parameters: {
          type: "object",
          properties: {},
        },
      },
    }
  ]
};
